export default __webpack_public_path__ + "static/media/node-sass.4d64b092.svg";